export const globalSettingsContextKey = "globalSettings";

export interface GlobalSettings {
	COOKIES: string;
	GOOGLE_ANALYTICS: string;
	VERSION: string;
	WEB_URL: string;
	WEB_URL_OR_LOCAL: string;
	ENV: string;
	ENV_DOMAIN: string;
	ROBOTS: "index" | "noindex";
	STORAGE_URL: string;
	UPLOAD_URL: string;
	PUBLIC_GRAPHQL_ENDPOINT: string;
	RECAPTCHA_SITE_KEY: string;
	ALGOLIA_APPLICATION_ID: string;
	ALGOLIA_API_SEARCH_KEY: string;
}
